module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-dune-timber-balmoral-1.597c8d5a.jpg";